import React from "react";
import { useTranslation } from "react-i18next";
import SvgIcon from "../../../../parts/SvgIcon";
import ToolTip from "../../../../parts/tooltip-portal";
import ColorSelectorPress from "./ColorSelectorPress";
import { CustomInput } from "./CustomInput";
import ImageSelector from "./ImageSelector";
import ThemeSelector from "./ThemeSelector";

export const PressStorefrontBrandingSection = ({
  active = false,
  handleChange,
  handleSwitch,
  state,
}) => {
  const { t } = useTranslation(["dashboard", "common"]);
  const {
    benefits,
    callLink,
    dayPassLink,
    formGymImg,
    formPressBannerImg,
    formPressPreviewImg,
    gymImg = {},
    gymImgChanged,
    gymName,
    pressBannerChanged,
    pressBannerImg,
    pressDescriptionSEO,
    pressFacebookLink,
    pressFavicon = {},
    pressFaviconChanged,
    pressFormFavicon = {},
    pressInstagramLink,
    pressPreviewImg,
    pressPreviewImgChanged,
    pressStorefrontMainColor,
    pressStorefrontSecondaryTextColor,
    pressStoreFrontTheme,
    pressTwitterLink,
    pressYoutubeLink,
  } = state;
  return (
    <div
      style={{
        display: active ? "block" : "none",
      }}
      className="storefront-section"
    >
      <article className="wrapper">
        <p className="s1">{t("branding.storefrontSetting")}</p>
        <section>
          <div className="left-column">
            <label>{t("branding.storefrontTheme")}</label>
            <ThemeSelector
              value={pressStoreFrontTheme}
              inputName="pressStoreFrontTheme"
              label={t("branding.storefrontTheme")}
              onChange={handleSwitch}
              isStorefront
              extraMargin
            />
            <ColorSelectorPress
              pressStorefrontMainColor={pressStorefrontMainColor}
              pressStorefrontSecondaryTextColor={
                pressStorefrontSecondaryTextColor
              }
              onChange={handleSwitch}
              onChangeColor={handleChange}
            />
          </div>
          <div className="right-column ">
            <img
              src={
                pressStoreFrontTheme === "dark"
                  ? "/img/press-storefront-dark.png"
                  : "/img/press-storefront-light.png"
              }
            />
          </div>
        </section>
      </article>
      <article className="wrapper">
        <p className="s1">{t("branding.settings")}</p>
        <label>{t("branding.gymName")}</label>
        <input
          name="gymName"
          className="text-input w-[calc(50%-0.75rem)]"
          placeholder={t("branding.enterGymNamePlaceholder")}
          value={gymName}
          onChange={handleChange}
          sz="large"
        />
        <section className="mt-6">
          <div className="left-side">
            <header>
              <label>
                {t("branding.bookCallLink")}{" "}
                <span className="label-explication">
                  {t("branding.egCalendly")}
                </span>
              </label>
              <ToolTip
                body={`${t("branding.bookCallLinkTooltip1")}\n${t(
                  "branding.bookCallLinkTooltip2"
                )}`}
              >
                <SvgIcon src="/img/new-icons/question-circle.svg" />
              </ToolTip>
            </header>
            <CustomInput
              name="callLink"
              onChange={handleChange}
              value={callLink}
              placeholder="http://"
            />
          </div>
          <div className="right-side">
            <header>
              <label>{t("branding.dayPassPaymentLink")}</label>
              <ToolTip
                body={`${t("branding.dayPassTooltip1")}\n${t(
                  "branding.dayPassTooltip2"
                )}`}
              >
                <SvgIcon src="/img/new-icons/question-circle.svg" />
              </ToolTip>
            </header>
            <CustomInput
              name="dayPassLink"
              onChange={handleChange}
              value={dayPassLink}
              placeholder="http://"
            />
          </div>
        </section>
      </article>
      <article>
        <p className="s1">{t("branding.content")}</p>
        <section>
          <div className="left-side">
            <header>
              <label>{t("branding.descriptionSeo")}</label>
              <ToolTip body={[t("branding.descriptionSeoTooltip")]}>
                <SvgIcon src="/img/new-icons/question-circle.svg" />
              </ToolTip>
            </header>
            <textarea
              name="pressDescriptionSEO"
              className="textarea-input"
              placeholder={t("branding.myDescriptionSeo")}
              value={pressDescriptionSEO}
              onChange={handleChange}
              maxLength={160}
              sz="large"
            />
          </div>
          <div className="right-side">
            <header>
              <label>{t("branding.descriptionBenefitsGym")}</label>
              <ToolTip body={[t("branding.descriptionBenefitsGymTooltip")]}>
                <SvgIcon src="/img/new-icons/question-circle.svg" />
              </ToolTip>
            </header>
            <textarea
              name="benefits"
              className="textarea-input"
              placeholder={t("branding.myDescriptionBenefitsGym")}
              value={benefits}
              onChange={handleChange}
              maxLength={500}
              sz="large"
            />
          </div>
        </section>
      </article>
      <article className="wrapper social-wrapper">
        <p className="s1">{t("branding.socialLinks")}</p>
        <section>
          <div className="left-side">
            <label>{t("branding.instagram")}</label>
            <CustomInput
              name="pressInstagramLink"
              placeholder="https://mystrengthbook.com"
              value={pressInstagramLink}
              onChange={handleChange}
            />
            <label>{t("branding.youtube")}</label>
            <CustomInput
              name="pressYoutubeLink"
              placeholder="https://mystrengthbook.com"
              value={pressYoutubeLink}
              onChange={handleChange}
            />
          </div>
          <div className="right-side">
            <label>{t("branding.twitter")}</label>
            <CustomInput
              name="pressTwitterLink"
              placeholder="https://mystrengthbook.com"
              value={pressTwitterLink}
              onChange={handleChange}
            />
            <label>{t("branding.facebook")}</label>
            <CustomInput
              name="pressFacebookLink"
              placeholder="https://mystrengthbook.com"
              value={pressFacebookLink}
              onChange={handleChange}
            />
          </div>
        </section>
      </article>
      <article className="wrapper images-wrapper">
        <p className="s1">{t("branding.graphics")}</p>
        <section>
          <ImageSelector
            title={t("branding.banner")}
            id="Press Banner"
            info={t("branding.pressBannerDimensions")}
            selectorTitle={t("branding.uploadBanner")}
            subInfo={
              <div>
                <span>{t("branding.imageFormatsJpgSvgPng")}</span>
                <span>{t("branding.pressBannerDimensions")}</span>
              </div>
            }
            buttonTitle={t("branding.editLogo")}
            imageDimensions={{
              marginTop: 0,
            }}
            inputName="pressCustomBranding[pressBannerImg]"
            imageInputs={[
              { name: "pressBannerChanged", value: pressBannerChanged },
              {
                name: "formPressBannerImgFile",
                value: formPressBannerImg.file || "",
              },
              {
                name: "formPressBannerImgType",
                value: formPressBannerImg.type || "",
              },
              {
                name: "formPressBannerImgName",
                value: formPressBannerImg.name || "",
              },
              {
                name: "formPressBannerImgS3Path",
                value: formPressBannerImg.s3Path,
              },
            ]}
            value={pressBannerImg}
            onChange={handleChange}
            showButton={false}
            toolTipTextBody={t("branding.requiredSizePressBanner")}
          />
          <ImageSelector
            title={t("branding.gymImage")}
            id="Gym Image"
            info={t("branding.gymImageDimensions")}
            selectorTitle={t("branding.uploadImage")}
            subInfo={
              <div>
                <span>{t("branding.imageFormatsJpgSvgPng")}</span>
                <span>{t("branding.maxSize800kb")}</span>
              </div>
            }
            imageDimensions={{
              marginTop: 0,
            }}
            buttonTitle={t("common:edit")}
            inputName="pressCustomBranding[gymImg]"
            imageInputs={[
              { name: "gymImgChanged", value: gymImgChanged },
              { name: "formGymImgFile", value: formGymImg.file || "" },
              { name: "formGymImgType", value: formGymImg.type || "" },
              { name: "formGymImgName", value: formGymImg.name || "" },
              {
                name: "formGymImgS3Path",
                value: formGymImg.s3Path,
              },
            ]}
            value={gymImg}
            onChange={handleChange}
            showButton={false}
            toolTipTextBody={t("branding.requiredSizeGymImage")}
          />
          <ImageSelector
            title={t("branding.customLinkPreview")}
            id="Press Preview"
            info={t("branding.previewDimensions")}
            selectorTitle={t("branding.uploadImage")}
            subInfo={
              <div>
                <span>{t("branding.imageFormatsJpgPng")}</span>
                <span>{t("branding.maxSize800kb")}</span>
              </div>
            }
            buttonTitle={t("common:edit")}
            imageDimensions={{
              marginTop: 0,
            }}
            inputName="pressCustomBranding[pressPreviewImg]"
            imageInputs={[
              {
                name: "pressPreviewImgChanged",
                value: pressPreviewImgChanged,
              },
              {
                name: "formPressPreviewImgFile",
                value: formPressPreviewImg.file || "",
              },
              {
                name: "formPressPreviewImgType",
                value: formPressPreviewImg.type || "",
              },
              {
                name: "formPressPreviewImgName",
                value: formPressPreviewImg.name || "",
              },
              {
                name: "formPressPreviewImgS3Path",
                value: formPressPreviewImg.s3Path,
              },
            ]}
            value={pressPreviewImg}
            onChange={handleChange}
            allowedExtensions="image/jpeg,image/png"
            showButton={false}
            toolTipTextBody={t("branding.requiredSizePreview")}
          />
          <ImageSelector
            title={t("branding.favicon")}
            id="Press Favicon"
            selectorTitle={t("branding.uploadImage")}
            subInfo={
              <div>
                <span>{t("branding.imageFormatsJpgSvgPng")}</span>
                <span>{t("branding.maxSize800kb")}</span>
              </div>
            }
            inputName="pressCustomBranding[pressFavicon]"
            imageInputs={[
              { name: "pressFaviconChanged", value: pressFaviconChanged },
              {
                name: "pressFormFaviconFile",
                value: pressFormFavicon.file || "",
              },
              {
                name: "pressFormFaviconType",
                value: pressFormFavicon.type || "",
              },
              {
                name: "pressFormFaviconName",
                value: pressFormFavicon.name || "",
              },
              {
                name: "pressFormFaviconS3Path",
                value: pressFormFavicon.s3Path,
              },
            ]}
            buttonTitle={t("common:edit")}
            value={pressFavicon}
            onChange={handleChange}
            imageDimensions={{
              marginTop: 0,
            }}
            showButton={false}
            toolTipTextBody={t("branding.maxSize800kbTooltip")}
          />
        </section>
      </article>
    </div>
  );
};
